<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">审核</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="">

        <el-form :model="dealFrom" :rules="rules" ref="dealForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="公司名称">
                  <el-input v-model="govName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="处理结果">
                  <el-select v-model="dealFrom.auditStatus" style="width:100%;">
                    <el-option
                        v-for="item in status_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="处理记录" required prop="auditMessage">
                  <el-input v-model="dealFrom.auditMessage" type="textarea" rows="5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('dealForm')">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Deal',
  props: [],
  data() {
    return {

      loading: false,

      dealFrom:{
        timeStr:timeStr,
        sign:'',
        auditMessage:'',
        auditStatus:1,
        governmentCode:'',
      },
      rules:{
        auditMessage:[
          { required: true, message: '请输入处理结果', trigger: 'blur' },
          { required: true, message: '请输入处理结果', trigger: 'change' },
        ],
      },

      govName:'',

      status_arr: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '驳回'
      }],



    }
  },

  methods: {

    init(row){

      //this.$refs.dealForm.resetFields();
      this.dealFrom.governmentCode=row.governmentCode;
      this.dealFrom.auditStatus = 1;
      this.dealFrom.auditMessage = '';
      this.govName = row.name;

    },

    closeSelf() {
      this.$emit("closeDeal");
    },

    confirm(dealForm){
      this.$refs[dealForm].validate((valid) => {
        if (valid) {
          this.addSubmit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.dealFrom.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Government/Audit",
        data: this.dealFrom,
      }).then(
          (response) => {
            //console.log(response);
            this.loading = false;

            if (response.data.error == 0) {
              this.$emit("closeDeal");
              this.$emit("getList",false);
            } else {
              this.$message({type: 'info', message: response.data.message});
            }

          }
      )
    },


  }
}


</script>





<style lang="scss" scoped>


</style>
